import { Tooltip as AntdTooltip, Flex } from 'antd';
import { InfoIcon } from 'common/all-icons/custom-icons';
import styles from './ColumnInfo.module.scss';

const ColumnInfo = ({ name = '', description = '', size = 16, className = '' }) => {
  if (!description) return null;

  return (
    <AntdTooltip
      title={
        <Flex vertical gap={4}>
          <div className="body-12-semibold">{name}</div>
          <div style={{ color: 'var(--user-main-text)' }} className="body-12-medium">
            {description}
          </div>
        </Flex>
      }
      placement="top"
      trigger={['hover', 'click']}
      color="var(--user-dropdown-bg)"
      overlayClassName={styles.infoTooltip}
    >
      <span
        className={`${styles.infoIcon} ${className}`}
        role="button"
        tabIndex={0}
        aria-label="Column description"
        onClick={(e) => e.stopPropagation()}
      >
        <InfoIcon width={size} height={size} stroke="var(--user-main-text-2)" strokeWidth={1.6} />
      </span>
    </AntdTooltip>
  );
};

export default ColumnInfo;
